<app-header></app-header>
<app-page-title></app-page-title>

<div class="col-lg-12">
<div class="row m-y">
  <div class="col-lg-3 d-flex-row">
    <div class="search-label">Start Date</div>
    <input autocomplete="off" pattern="^[^<>]*$" style="width: 100%;" type="text"
           placeholder="Start Date"
           class="form-control"
           #dp="bsDatepicker"
           bsDatepicker

           [maxDate]="maxStartDate"
           (bsValueChange)="onStartDateChange($event)">
    <timepicker  [showMeridian]="false" [(ngModel)]="startReportTime"></timepicker>

  </div>

  <div class="col-lg-3 d-flex-row">
    <div class="search-label">End Date</div>
    <input autocomplete="off" pattern="^[^<>]*$"  style="width: 100%;" type="text"
            placeholder="End Date"
            class="form-control"
            #dp="bsDatepicker"
            bsDatepicker

            [maxDate]="maxEndDate"
            (bsValueChange)="onEndDateChange($event)">
    <timepicker  [showMeridian]="false" [(ngModel)]="endReportTime"></timepicker>

  </div>
</div>
  <div class="row">
  <div class="col-md-3 col-lg-1-5">
    <div class="search-label">Aggregation</div>
    <select [(ngModel)]="aggregationFilter" class="form-control">
      <!-- <option  value="">Aggregation</option> -->
      <option  value="1">Average</option>
      <option  value="2">Minimum</option>
      <option  value="3">Maximum </option>
    </select>
  </div>
  <div class="col-md-3 col-lg-1-5">
    <div class="search-label">Time Interval</div>
    <select [(ngModel)]="timeIntervalFilter" class="form-control">
      <option  *ngFor="let item of timeIntervalArray; index as i" value="{{i+1}}"> {{item}}</option>
    </select>
  </div>
  <div class="col-md-3 col-lg-2-5">
    <div class="search-label">Select Region</div>
    <select [(ngModel)]="regionFilter" class="form-control" (change) = "getCategoryList($event)">
      <option value="">All Region </option>
      <option *ngFor="let regionRow of regionList"  value="{{regionRow.region_name}}"> {{regionRow.region_name}} </option>
    </select>
  </div>
  <div class="col-md-3 col-lg-3-5">
    <div class="search-label">Category Type</div>
    <select [(ngModel)]="categoryFilter" class="form-control" (change) = "getTimeUnitList($event)">
      <option value="">All Category Type </option>
      <option *ngFor="let category of categoryList"  value="{{category.industry_category}}">{{category.industry_category}}</option>
    </select>
  </div>
  <div class="col-md-3 col-lg-4-5">
    <div class="search-label">Unit Station Type</div>
     <select [(ngModel)]="unitTypeFilter" class="form-control" (change) = "getVendorList($event)">
       <option value=""> All Unit Station Type </option>
      <option *ngFor="let item of timeUnitList"  value="{{item.stdunit}}"> {{item.stdunit}} </option>
    </select>
  </div>
  <div class="col-md-3 col-lg-4-5">
    <div class="search-label">Vendor</div>
    <select [(ngModel)]="vendorFilter" class="form-control" (change) = "getIndustryList($event)">
      <option value="">All Vendor</option>
      <option *ngFor="let vendor of vendorList"  value="{{vendor.id}}"> {{vendor.vendor_name}} </option>
    </select>
  </div>
  <div class="col-md-3 col-lg-4-5">
    <div class="search-label"> Unit Station</div>
    <!-- <select [(ngModel)]="industryFilter" class="form-control" (change) = "getStationList($event)">
      <option value=""> All Industry </option>
      <option *ngFor="let industry of industryList"  value="{{industry.id}}"> {{industry.name}} </option>
    </select> -->
    <ng-multiselect-dropdown
       class="form-control multi"
       [data]="industryList"
       [(ngModel)]="industryFilter"
       [settings]="industrySettings"
       (onSelect)="getStationList($event)"
       (onSelectAll)="getStationList($event ,'all')"
       (onDeSelect)="getStationList($event)"
       >
    </ng-multiselect-dropdown>
  </div>
  <div class="col-md-3 col-lg-4-5">
    <div class="search-label">Station</div>
    <!-- <select [(ngModel)]="stationFilter" class="form-control">
      <option value=""> All Station </option>
      <option *ngFor="let station of stationList"  value="{{station.id}}"> {{station.name}} </option>
    </select> -->
    <ng-multiselect-dropdown
      class="form-control multi"
       [data]="stationList"
       [(ngModel)]="stationFilter"
       [settings]="stationSettings"
       >
      </ng-multiselect-dropdown>
  </div>
</div>


  <div class="col-lg-12 center m-y">
    <button class="btn btn-primary" (click)="getReport()" [disabled]="disabled"> <i class="icon icon-search4"></i> Search </button>
  </div>
</div>

  <div class="page-container">

    <!-- Page content -->
    <div class="page-content">

      <!-- Main content -->
      <div class="content-wrapper">

        <div class="row">

            <div  class="panel panel-flat">
              <div class="panel-body">
                <div class="col-md-9 h5 text-justify" style="padding-left: 0;">
                  <span>Monitoring Report of OCEMS
                    {{otherDetails.industry_name?("of "+otherDetails.industry_name):""}}
                     {{otherDetails.industry_address?otherDetails.industry_address:""}}
                      for the period from {{otherDetails.start_date | date}} {{otherDetails.start_date | date: 'shortTime'}}
                      To {{otherDetails.end_date | date}} {{otherDetails.end_date | date: 'shortTime'}}
                    {{otherDetails.time_interval?(" for time interval "+ otherDetails.time_interval | titlecase):""}}
                    .
                  </span>
                  <!--<span style="margin-left: 30px; font-weight: 500; font-size: 10px;" class="text-muted">20/06/2018 - 17-07-2018</span>-->
                </div>

                <div class=" col-md-3" style="text-align: right;" >
                  <button style="margin-right: 10px; cursor: pointer !important;" type="button" class="btn btn-xs btn-info"><strong>Total Stations </strong>  <span class="badge badge-info">{{closeIndustryList.length}}</span></button>
                  <a title="Export Excel." (click)="exportReport('excel')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
                    <i class="icon icon-file-excel"></i>
                  </a>
                  <a id="exportexcelhref" target="_blank"></a>&nbsp;
                  <a title="Export PDF." (click)="exportReport('pdf')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important; margin-right: 10px;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
                    <i class="icon icon-file-pdf"></i>
                  </a>
                  <a id="exportpdfhref" target="_blank"></a>

                </div>

              </div>

              <table class="table datatable-show-all">
                <thead>
                <tr>
                  <th colspan="2" class="w-50">HROCMMs ID</th>
                  <th class="w-50">{{otherDetails.hr_ocmms_id ? otherDetails.hr_ocmms_id : ""}}</th>
                </tr>
                <tr>
                  <th colspan="2" class="w-50">Unit Station name</th>
                  <th class="w-50">{{otherDetails.industry_name? (otherDetails.industry_name | titlecase):""}}</th>
                </tr>
                <tr>
                  <th colspan="2" class="w-50">Unit Station address</th>
                  <th class="w-50">{{otherDetails.industry_address? (otherDetails.industry_address | titlecase) :""}}</th>
                </tr>
                <tr>
                  <th colspan="2" class="w-50">Category type & category</th>
                  <th class="w-50">
                    {{categoryFilter ? categoryFilter : (otherDetails.industry_category ? (otherDetails.industry_category | titlecase) : '') }}
                    {{unitTypeFilter ? ' (' + (unitTypeFilter | titlecase) + ')' : ( otherDetails.industry_type? ' (' + (otherDetails.industry_type | titlecase) + ')': '')}}
                  </th>
                </tr>
                <tr>
                  <th colspan="2" class="w-50">Regional office</th>
                  <th class="w-50">{{otherDetails.region?(otherDetails.region | titlecase):""}}</th>
                </tr>
                <tr>
                  <th colspan="2" class="w-50">Period & Time interval</th>
                  <th class="w-50">{{otherDetails.start_date | date}} {{otherDetails.start_date | date : 'shortTime'}} - {{otherDetails.end_date | date}} {{otherDetails.end_date | date : 'shortTime'}}{{otherDetails.time_interval? " ("+(otherDetails.time_interval | titlecase)+")":""}}</th>
                </tr>
                </thead>
              </table>
              <div class="table-responsive">
              <table>
                <tbody>
                  <tr *ngIf="!regionLoader && closeIndustryList.length">
                    <th >
                       <div class="px-2" *ngFor="let char of ['St','ati','on','  ','na','me']">{{char}}</div>
                    </th>
                    <th *ngFor="let int of closeIndustryList; i as index" colspan="3">
                      <div class="set-height"><b>{{int[0][0]['station_name'] | titlecase}}</b></div>
                       <table>
                        <thead>
                          <tr colspan="3">
                            <th *ngFor="let cell of int">
                              <div class="center"><b>{{cell[0]['parammetric']}} ({{cell[0]['stdunit']}})</b></div>
                              <table>
                                <thead>
                                  <tr>
                                    <th><u>Response Date</u></th>
                                    <th><u>Response Value</u></th>
                                    <th><u>Prescribed Value</u></th>
                                  </tr>
                                <tr *ngFor="let cellData of cell">
                                  <th><b>{{cellData['min_response_date_time'] | date}} {{cellData['min_response_date_time'] | date : 'shortTime'}}</b></th>
                                  <th><b>{{cellData['response_value']}}</b></th>

                                  <th *ngIf="cellData['min'] && cellData['max']"><b>{{cellData['min']}}</b> - <b>{{cellData['max']}}</b></th>
                                  <th *ngIf="cellData['min'] && !cellData['max']"><b>{{cellData['min']}}</b></th>
                                  <th *ngIf="!cellData['min'] && cellData['max']"><b>{{cellData['max']}}</b></th>
                                  <th *ngIf="!cellData['min'] && !cellData['max']"><b>N/A</b></th>
                                </tr>
                                </thead>
                              </table>
                            </th>
                          </tr>
                        </thead>
                       </table>
                    </th>
                  </tr>

                </tbody>
              </table>
            </div>
            <div *ngIf="!regionLoader && (!closeIndustryList.length) && (!initState)"  class="col-lg-12 text-center" style="height: 180px;">
              <div style="font-size: 28px; font-weight: 600; color: red; margin-top: 50px;">
                No  Unit Station Report Found
              </div>
            </div>
              <div *ngIf="regionLoader">
                <div colspan="12" class="col-lg-12 text-center" style="height: 180px;">
                  <div style="margin-top: 50px;">
                    <img src="/assets/images/load.gif" />
                  </div>
                </div>
              </div>
            </div>



        </div>

      </div>
    </div>
  </div>

<app-footer></app-footer>
